module.exports = __webpack_public_path__ + "static/ko-fi-39e8e67c54ba4b8885c0b8fddb38d0d4.png";